import React, { Component } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PaymentHistory from './PaymentHistory';
import AddPayment from './AddPayment';
import PaymentReports from './PaymentReports';

class PaymentManagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'history'
        };
    }

    render() {
        const { activeTab } = this.state;

        return (
            <div className="payment-management-container">
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => this.setState({ activeTab: k })}
                    className="mb-4"
                >
                    {/* Onglet Historique des paiements */}
                    <Tab
                        eventKey="history"
                        title={
                            <span>
                                <i className="fa fa-history me-2"></i>
                                Historique des paiements
                            </span>
                        }
                    >
                        <PaymentHistory />
                    </Tab>

                    {/* Onglet Ajouter un paiement */}
                    <Tab
                        eventKey="add"
                        title={
                            <span>
                                <i className="fa fa-plus-circle me-2"></i>
                                Ajouter un paiement
                            </span>
                        }
                    >
                        <AddPayment />
                    </Tab>

                    {/* Onglet Rapports et statistiques */}
                    <Tab
                        eventKey="reports"
                        title={
                            <span>
                                <i className="fa fa-chart-bar me-2"></i>
                                Rapports et statistiques
                            </span>
                        }
                    >
                        <PaymentReports />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default PaymentManagement;